/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';

import BackgroundImage from '../../BackgroundImage';
import { formatPlayerShots, getThirdPartyRanking, getRatingDetails, setRatingChoice } from '../../../utils';
import styles from './organizer.scss';
import { eventGenderTypeIds, directorRoleIds } from '../../../utils/eventConstants';
import { ratingTypes } from '../../../utils/constants';
import { EventTypes } from '../../../utils/events';

const OrganizerCardV2 = (props) => {
    const { organizer, user, sendMessage, className, paidHit, eventTypeId, providerEmail } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);

    const isFlexLeagueEvent = eventTypeId === EventTypes.FLEX_LEAGUE;

    const About = () => {
        const {
            description,
            atpOrWtaRank,
            backhand,
            college,
            collegeData,
            collegePosition,
            dominantHand,
            isPro,
            genderId,
            thirdPartyRankings,
            coachingExperienceStatus,
            coachingExperienceTypeId,
            playerExperienceStatus,
            playerExperienceTypeId,
        } = organizer;

        const atpWtaRank = getThirdPartyRanking(thirdPartyRankings, genderId === eventGenderTypeIds.FEMALE ? 'WTA' : 'ATP', isPro);
        const playerRating = getRatingDetails(setRatingChoice({ player: organizer, utrType: 'sanctioned' }), user?.isPowered, true);
        const { playerExperienceTypes, coachingExperienceTypes } = coreUI.types;

        const aboutData = [];

        if (description) {
            aboutData.push({
                title: 'Description',
                value: description,
            });
        }

        if (playerRating) {
            aboutData.push({
                title: `${ratingTypes.tennis} Rating`,
                value: playerRating.value,
            });
        }

        if (backhand || dominantHand) {
            aboutData.push({
                title: 'Dominant Hand',
                value: formatPlayerShots(dominantHand, backhand),
            });
        }
        if (college && collegeData) {
            aboutData.push({
                title: 'College',
                value: `${collegeData.displayName} ${collegePosition && `#${collegePosition}`}`,
            });
        }

        if ((isPro || atpOrWtaRank) && atpWtaRank.length > 0) {
            aboutData.push({
                title: `${genderId === eventGenderTypeIds.FEMALE ? 'WTA' : 'ATP'} Rank`,
                value: atpWtaRank,
            });
        }
        if (playerExperienceTypeId && playerExperienceStatus) {
            aboutData.push({
                title: 'Playing Experience',
                value: `${playerExperienceStatus} ${playerExperienceTypes.find(type => type.id === playerExperienceTypeId)?.label}`,
            });
        }
        if (coachingExperienceTypeId && coachingExperienceStatus) {
            aboutData.push({
                title: 'Coaching Experience',
                value: `${coachingExperienceStatus} ${coachingExperienceTypes.find(type => type.id === coachingExperienceTypeId)?.label}`,
            });
        }
        return (
            <div className={`${styles.about}`}>
                {aboutData.map((data, i) => {
                    return (
                        <div
                            className={`${styles.value}`}
                            key={`about-item-${i}`}
                        >
                            {data.title}
                            <span className={`${styles.bold}`}>
                                {data.value}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className={`organizer-card ${className}`}>
            <div className="d-flex">
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={organizer.playerProfileImages}
                    imageType={'icon'}
                    parentStylesClass={'avatar flex-shrink-0'}
                />
                <div className={`person-details`}>
                    <div
                        className={`text-medium text-dark ${organizer.playerId ? 'cursor-pointer' : ''}`}
                        onClick={() => {
                            if (organizer.playerId) {
                                window.location.href = `/profiles/${organizer.playerId}`;
                            }
                        }}
                    >
                        {`${organizer.firstName} ${organizer.lastName}`}
                    </div>
                    {organizer.eventDirectorRoleId === directorRoleIds.VOLUNTEER
                        ? <div className="text-small text-uppercase">Volunteer</div>
                        : <div className="text-small text-uppercase">{paidHit ? 'Paid Hitter' : 'Provider'}</div>}
                </div>
                {isFlexLeagueEvent ? (
                    <div className={`message`}>
                        {providerEmail && (
                            <div className="col-12 mb16">
                                <a href={`mailto:${providerEmail}`}><i className="uts uts-email" /></a>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={`message`}>
                        {(organizer.memberId && user && user.id && user.id.toString() !== organizer.memberId) && (
                            <div className={`click-area click-area-36`} onClick={() => sendMessage(organizer)}>
                                <i className={`utr utr-message fs24 text-teal`} />
                            </div>
                        )}
                    </div>
                )}
            </div>
            {(paidHit && Object.keys(organizer).length > 0) && (
                <div>
                    <hr className="div" />
                    <About />
                </div>
            )}
        </div>
    );
};

export default OrganizerCardV2;
